<template>
    <div style="padding-top:20px;">
        <el-row >
            <el-col :span="6">
                <div class="main-left">
                    <div class="left-top">
                        <el-card class="box-card">
                            <div class="user-box">
                                <div class="user-avatar-box">
                                    <img class="user-avatar" :src="source_prefix + userInfo.avatar" alt="">
                                </div>
                                <div class="user-nickname">
                                    用户名：{{userInfo.nickname}}
                                </div>
                                <div class="user-signature">
                                    签名：{{userInfo.signature}}
                                </div>
                            </div>
  
                        </el-card>
                    </div>
                    <div class="left-bottom">
                        <el-card class="box-card">
                            <div style="padding-bottom: 30px;">
                                <div class="left-title-box">
                                    <div class="vip-logo">
                                        <img src="http://foo.ibianma.com/jingying/word/2022/12/05/4d0aa8de671f5466fd1898e4036814c2.png" alt="" style="width:100%">
                                    </div>
                                    <div class="title-content">
                                        个人中心
                                    </div>
         
                                </div>
                                <div>
                                    <div v-for="(item, index) in operateMaps" :key="index" class="operate-box">
                                        <div class="">
                                            <i :class="[item.logo, 'operate-logo']" @click="clickOperate(item)"></i>
                                            <span class="operate-text" @click="clickOperate(item)">{{item.text}}</span>
                                        </div>
                              
                                    </div>
                                </div>
       
                            </div>

                        </el-card>
                    </div>
                </div>


            </el-col>
            <el-col :span="18">
                <div class="main-right">
                    <el-card class="box-card">
                        <div class="right-box">
                            <div class="right-title-box">
                                <div class="vip-logo">
                                    <img src="http://foo.ibianma.com/jingying/word/2022/12/05/4d0aa8de671f5466fd1898e4036814c2.png" alt="" style="width:100%">
                                </div>
                                <div class="vip-end-time">
                                    {{userInfo.vip_data.end_time ? userInfo.vip_data.end_time : ''}}到期
                                </div>
        
                            </div>

                            <div>
                                <el-row>
                                    <el-col :span="8" v-for="( item, index ) in abilityMaps" :key="index" class="card-item">
                                        <div class="card-box-item">
                                            <div class="ability-img-box">
                                                <img :src="item.imgUrl" alt="" style="width:80%">
                                            </div>
                                            <div>
                                                <div class="ability-title">{{item.title}}</div>
                                                <div class="ability-desc">{{item.desc}}</div>
                                            </div>
                                        </div>
                                    </el-col>
                                </el-row>
                                
                            </div>
                        </div>
                    </el-card>
                </div>

            </el-col>
        </el-row>
    </div>
</template>
<script>

</script>


<script>
    import { realQuestionsList} from '@/api'
    import store from '@/store'
    export default {
        name: 'UserInfo',
        props: ['cate', 'words'],
        data() {
            return {
                list:[],
                operateMaps:[
                    {
                        logo:"el-icon-school",
                        text:"设置学校",
                        tag:"",
                    },    
                    {
                        logo:"el-icon-edit-outline",
                        text:"编辑资料",
                        tag:"",
                    },
                    {
                        logo:"el-icon-s-opportunity",
                        text:"安全中心",
                        tag:"",
                    },
                    {
                        logo:"el-icon-s-custom",
                        text:"退出登录",
                        tag:"logout",
                    }, 
                ],
                abilityMaps:[
                    {
                        imgUrl:"https://foo.ibianma.com/jingying/word/2022/12/05/6f67ce27ea0348cc7720b3747ccf7d40.png",
                        title:"课程中心",
                        desc:"学海无涯苦做舟",
                        tag:"kecheng"
                    }, 
                    {
                        imgUrl:"https://foo.ibianma.com/jingying/word/2022/12/05/22fa2781104f4be1e4fc7ab3b26af3a6.png",
                        title:"我的收藏",
                        desc:"宝藏课程",
                        tag:"shoucang"
                    }, 
                    {
                        imgUrl:"https://foo.ibianma.com/jingying/word/2022/12/05/33c7149b79522ab1b80cab49e6e6d714.png",
                        title:"今币商城",
                        desc:"更多课程",
                        tag:"jinbi"
                    }, 
                    {
                        imgUrl:"https://foo.ibianma.com/jingying/word/2022/12/05/ba1c2c7a04b9fb80d8ef657f34a1c57a.png",
                        title:"订单记录",
                        desc:"我购买过的课程",
                        tag:"dingdan"
                    }, 
                    {
                        imgUrl:"https://foo.ibianma.com/jingying/word/2022/12/05/f9fd11b98ad977c89b8cbc7b2c4683d8.png",
                        title:"钻石充值",
                        desc:"兑换更多商品",
                        tag:"zuanshi"
                    }, 
                    {
                        imgUrl:"https://foo.ibianma.com/jingying/word/2022/12/05/92d23af91e701320a4562a44dd1d441e.png",
                        title:"意见反馈",
                        desc:"你的意见我来改",
                        tag:"fankui"
                    }, 
                    {
                        imgUrl:"https://foo.ibianma.com/jingying/word/2022/12/05/215b3b0e9fd67214637ec4390b82946c.png",
                        title:"关于我们",
                        desc:"联系我们",
                        tag:"kefu"
                    } 
          
                ],
                form:{
                    page: 1,
                    limit: 99,
                    work_second_category_id: -1
                },
                source_prefix:process.env.VUE_APP_UPYUN_PATH,
            }
        },
        components: {
        },

        methods: {
            realQuestionsList()
            {
                realQuestionsList(this.form).then(response => {
                    this.list = response.data
                })
            },
            clickOperate(e){
                switch(e.tag) {
                    case 'logout':
                    this.$confirm('确定要退出', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'error'
                    }).then(() => {
                        // 开启转圈圈
                        store.dispatch('user/logout');
                        this.$router.push({path:'/login'})
                        this.$message({
                            type: 'success',
                            message: '退出成功'
                        })
            
                    }).catch(() => {
                        this.$notify.info({
                        title: '信息提示',
                        message: '已取消此操作',
                        duration: 3000
                        })
                    })
                        break;
                    case 'HOMEWORK':
                        
                        break;
                    case 'EXERCISE':
                        
                        break;
                        
                    default:
                        
                } 
                
            }

        },
        
        mounted() {

        },
        computed: {
            userInfo() {
                return this.$store.state.user.userInfo
            }
        },
        watch: {
            userInfo: {
                immediate: true,
                handler: (n, o) => {

                }
            }
        }
    }
</script>
<style scoped lang="less">
    .main-left{
        padding:0 20px;
    }

    .main-right{
        padding:0 20px 0 0;
    }

    .left-top{
        text-align: center;
    }

    .user-box{
        padding:50px 0 40px 0;
    }
    .user-avatar-box{
        margin-bottom:20px;
    }
    .right-box{
        min-height:86vh;
    }
    .user-avatar{
        width:40%;
        border-radius: 50%;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
    }
    .user-nickname{
        height: 20px;
        font-size: 20px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #333333;
    }
    .user-signature{
        margin-top:20px;
        height: 20px;
        font-size: 20px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #666666;
        width:100%;
        overflow: hidden;
    }

    .left-bottom{
        margin-top:30px;
        
    }
    .vip-logo{
        width: 40px;
    }

    .left-title-box{
       

        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        padding: 30px 0 20px 0;
        border-bottom:2px solid  #FAFBFC;


    }

    .right-title-box{
        padding-left:50px;
        display: flex;
        width: 100%;
        border-bottom:2px solid  #FAFBFC;
    }
    .vip-logo2{
    
    }

    .vip-end-time{
        font-size: 20px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #1D1D1D;
        padding-left: 10px;
        height:30px;
        line-height: 30px;
        margin-top:5px;
        
    }

    .title-content{

        font-size: 20px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #1D1D1D;
        padding-left: 10px;
    }

    .operate-box{
        text-align: center;
        margin-top:40px;
    }
    .operate-text{
        padding-left: 20px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #3A3A3A;
        font-size: 20px;
        cursor: pointer;
    }
    .operate-logo{
        font-size: 20px;
        cursor: pointer;
    }

    .card-item{
        margin-top:40px;
      
    }

    .card-box-item{
        width:75%;
        margin:auto;
        padding:10px;
        background: #FFFFFF;
        border: 10px solid #F4F7F9;
        box-shadow: 0px 2px 8px 0px rgba(38,38,38,0.11);
        border-radius: 10px;
        display: flex;
        cursor: pointer;
    }

    .ability-img-box{
        width:40%;

    }

    .ability-title{
        height: 20px;
        font-size: 20px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #3A3A3A;
        line-height: 19px;
        margin-top: 20px;
    }

    .ability-desc{
        height: 17px;
        font-size: 18px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #3A3A3A;
        line-height: 19px;
        opacity: 0.8;
        margin-top: 15px;
    }

    @media (max-width: 1400px) {
        .card-box-item{
            width:88%;
        }

        .ability-img-box{
            width:35%;

        }
        .ability-title{
            margin-top: 10px;
        }
        .ability-desc{
            margin-top: 6px;
        }
    }

</style>
